import React from "react";
import Info from "./components/Info";
import About from "./components/About";

export default function Agenda() {
  return (
    <>
      <div className="agenda-page-top"></div>
      <Info backgroundColor="#f5fdfd" />
      <About />
    </>
  );
}
